import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { OutletProvider } from "@/contexts/OutletContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import POS from "@/pages/POS";
import Orders from "@/pages/Orders";
import MenuManagement from "@/pages/MenuManagement";
import Inventory from "@/pages/Inventory";
import Dashboard from "@/pages/Dashboard";
import Settings from "@/pages/Settings";
import Franchisees from "@/pages/Franchisees";
import Outlets from "@/pages/Outlets";
import Expenses from "@/pages/Expenses";
import Salaries from "@/pages/Salaries";
import PnL from "@/pages/PnL";

function Protected({ children, adminOnly, superAdminOnly }) {
  const { staff, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-stone-500">Loading…</div>;
  if (!staff) return <Navigate to="/login" replace />;
  if (superAdminOnly && staff.role !== "super_admin") return <Navigate to="/pos" replace />;
  if (adminOnly && staff.role !== "super_admin" && staff.role !== "admin") return <Navigate to="/pos" replace />;
  return children;
}

function AppWithOutlet() {
  const { staff } = useAuth();
  return (
    <OutletProvider staff={staff}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<Protected><Layout /></Protected>}>
          <Route path="/" element={<Navigate to="/pos" replace />} />
          <Route path="/pos" element={<POS />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/menu" element={<Protected adminOnly><MenuManagement /></Protected>} />
          <Route path="/inventory" element={<Protected adminOnly><Inventory /></Protected>} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/settings" element={<Protected adminOnly><Settings /></Protected>} />
          <Route path="/franchisees" element={<Protected superAdminOnly><Franchisees /></Protected>} />
          <Route path="/outlets" element={<Protected superAdminOnly><Outlets /></Protected>} />
          <Route path="/expenses" element={<Protected><Expenses /></Protected>} />
          <Route path="/salaries" element={<Protected superAdminOnly><Salaries /></Protected>} />
          <Route path="/pnl" element={<Protected superAdminOnly><PnL /></Protected>} />
        </Route>
        <Route path="*" element={<Navigate to="/pos" replace />} />
      </Routes>
    </OutletProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppWithOutlet />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
